import { VueWizard } from "@/vue-wizard";
import { Component } from "vue-property-decorator";
import {FormData} from '@/app/interfaces';
import $ from 'jquery';
import {fromEvent, Subscription} from "rxjs";
import {first} from "rxjs/operators";
const _ = require('lodash');

@Component({
    name: "register-form"
})
export default class RegisterForm extends VueWizard {

    public formData: FormData;

    private lockPasteSubscription: Subscription | null;
    private documentNumberChangeSubscription: Subscription | null;
    private companyNameEditionSubscription: Subscription | null;

    private showPassword = false;
    private showConfirmationPassword = false;

    constructor() {
        super();
        this.formData = _.cloneDeep(this.$store.state.formData);
        this.lockPasteSubscription = null;
        this.documentNumberChangeSubscription = null;
        this.companyNameEditionSubscription = null;
    }

    mounted(){
        this.$nextTick(() => $(() => ($('[data-toggle="tooltip"]') as any).tooltip()))
        this.lockPasteOnNoPasteInputs();
        this.initAutoCalculationOfCompanyName();
        this.generateCompanyName();
    }

    beforeDestroy() {
        if(this.lockPasteSubscription) {
            this.lockPasteSubscription.unsubscribe();
            this.lockPasteSubscription = null;
        }
        this.unsubscribeFromDocumentNumberChangeSubscription();
        if(this.companyNameEditionSubscription) {
            this.companyNameEditionSubscription.unsubscribe();
            this.companyNameEditionSubscription = null;
        }
    }

    get isTypeDocument(): boolean {
        return this.formData.typeDocument.toString().length > 0
    }

    get isNumberDocument(): boolean {
        return this.formData.numberDocument.toString().length > 0
    }

    get isPassword(): boolean {
        return this.formData.password.toString().length > 0
    }

    get typeDocuments() {
        return {
            CC: "CC",
            CE: "CE",
            PA: "PA",
            TI: "TI",
            NIT: "NIT"
        }
    }

    get equalPasswords(): boolean {
        const {password, confPassword} = this.formData
        return !this.isPassword
            || confPassword.toString().length <= 0
            || password.toString() === confPassword.toString()
    }

    get equalNumberDocuments(): boolean {
        const {numberDocument, confirmNumberDocument} = this.formData
        return !this.isNumberDocument
            || confirmNumberDocument.toString().length <= 0
            || numberDocument.toString() === confirmNumberDocument.toString()
    }

    get isValidPassword() {
        const passwordNumberEvaluation = new RegExp('\\d+')
        const passwordTextEvaluation = new RegExp('[a-zA-Z]+')
        return this.isPassword
            ? passwordNumberEvaluation.test(this.formData.password.toString()) &&
              passwordTextEvaluation.test(this.formData.password.toString())
            : true;
    }

    lockPasteOnNoPasteInputs() {
        this.lockPasteSubscription = fromEvent($('.no-paste'), 'paste').subscribe(
            (event) => event.preventDefault()
        )
    }

    initAutoCalculationOfCompanyName() {
        this.documentNumberChangeSubscription = fromEvent($('#documentNumber'), 'input').subscribe(
            () => this.generateCompanyName()
        )
        this.companyNameEditionSubscription = fromEvent($('#companyName'), 'input').pipe(
            first()
        ).subscribe(
            () => this.unsubscribeFromDocumentNumberChangeSubscription()
        )
    }

    generateCompanyName() {
        this.formData.companyName = "ACME" + `${this.isNumberDocument ? ' - ' + this.formData.numberDocument : ''}`;
    }

    unsubscribeFromDocumentNumberChangeSubscription() {
        if(this.documentNumberChangeSubscription) {
            this.documentNumberChangeSubscription.unsubscribe();
            this.documentNumberChangeSubscription = null;
        }
    }

    register() {
        this.formData.name = this.formData.name.trim();
        this.formData.lastName = this.formData.lastName.trim();
        this.$store.commit('setCompanyName', this.formData.companyName);
        this.$store.commit('setFormData', this.formData);
        const registerActions = _.cloneDeep(this.$store.state.registerActions);
        registerActions[1].isBlocked = false;
        this.$store.commit('setRegisterActions', registerActions);
        this.$store.commit('setCurrentActionIndex', 1);
    }

    toggleShowPassword(){
        this.showPassword = !this.showPassword;
    }

    toggleShowConfirmationPassword(){
        this.showConfirmationPassword = !this.showConfirmationPassword;
    }

}